import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '@services/api.service';
import { map } from 'rxjs/operators';
import { LoggerService } from '@services/logger.service';
import { BrandModel } from '@/models/tables/brand.model';

@Injectable({
  providedIn: 'root',
})
export class BrandsService extends ApiService {
  getAll(): Observable<any> {
    return this.http.get<any>(this.baseUrl + `/tables/brands`);
  }

  deleteBrand(brandId: number) {
    return this.http.delete(this.baseUrl + `/tables/brands/${brandId}/`).pipe(
      map((response: any) => {
        LoggerService.log(response, 'deleteBrand');
        return response;
      }),
    );
  }

  saveBrand(brand: BrandModel) {
    return this.http.post(this.baseUrl + `/tables/brands/save`, brand).pipe(
      map((response: any) => {
        LoggerService.log(response, 'saveBrand');
        return response;
      }),
    );
  }
}
